import { SearchBox } from '@components/index';
import { iSponsor } from '@interfaces/interfaces';
import Fuse from 'fuse.js';
import React, { ReactElement } from 'react';

interface iSponsorInfoData {
  data: iSponsor[];
}

const SearchBySponsor = ({ data }: iSponsorInfoData): ReactElement => {
  const fuseOptions = {
    keys: ['OrgName'],
    threshold: 0.4,
  };

  const sortedData = data.sort((a, b) => a.OrgName.trim().localeCompare(b.OrgName.trim()));
  const fuse = new Fuse(sortedData, fuseOptions);

  const getSuggestions = (inpuValue: string, setSuggestions: any) => {
    if (!inpuValue) setSuggestions([]);
    const suggest = fuse
      .search(inpuValue)
      .map((result) => result.item)
      .slice(0, 5);
    setSuggestions(suggest);
  };

  const getSuggestionValue = (suggestion: iSponsor): string => {
    const suggestionValue = suggestion.OrgName;
    if (suggestionValue) return suggestionValue;
    return '';
  };

  const renderSuggestion = (suggestion: iSponsor): ReactElement => {
    const suggestionString = suggestion.OrgName;
    if (suggestionString) {
      return <div dangerouslySetInnerHTML={{ __html: suggestion.OrgName }} />;
    }
    return <></>;
  };

  const handleSearchBySponsor = (searchInput: string) => fuse.search(searchInput).map((result) => result.item);

  return <SearchBox data={sortedData} searchFn={handleSearchBySponsor} getSuggestions={getSuggestions} getSuggestionValue={getSuggestionValue} renderSuggestion={renderSuggestion} />;
};

export default SearchBySponsor;
